import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Switch from "material-ui/Switch";
import Grid from "material-ui/Grid";
import Radio, { RadioGroup } from "material-ui/Radio";
import { toast } from "react-toastify";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

import { CUSTOM_METADATA_STANDARD } from "../../../common/constants";
import { isVDVType } from "../../../common/utils";

class EditTests extends React.Component {
  constructor(props) {
    super(props);
    const { job, test } = props;
    this.state = {
      editSaving: false,
      open: true,
      errors: {},
      tabs: [
        props.translate("test_details"),
        props.translate("test_standards"),
        props.translate("test_nvp"),
        props.translate("test_edit_details"),
        test && test.metadatalookupid === CUSTOM_METADATA_STANDARD
          ? props.translate("test_metadata")
          : null
      ],
      tabPosition: 0,
      tabCounts: {
        comet: {
          single: {
            standard: 4,
            custom: 5
          },
          multiple: {
            standard: 3,
            custom: 4
          }
        },
        lantek: {
          single: 3,
          multiple: 2
        },
        mobile: {
          single: 2,
          multiple: 1
        }
        // cometSingle: 3,
        // cometSingleCustom: 4,
        // cometMuliple: 2,
        // cometMulipleCustom: 3,
        // lantekSingle: 2,
        // lantekMultiple: 1
      },
      test: {
        jobid: job.id,
        name: "",
        floor: "",
        telecommunicationspace: "",
        panel: "",
        cablestandard: "",
        cablestandardname: "",
        linkmodel: "",
        linkmodelname: "",
        cabletype: "",
        cabletypename: "",
        cablebrand: "",
        cablebrandname: "",
        cablemodelid: "",
        cablemodelname: "",
        connectorbrandnear: "",
        connectorbrandnearname: "",
        connectorbrandfar: "",
        connectorbrandfarname: "",
        nvp: "",
        cableshielding: "",
        metadata: [
          {
            level: "1",
            value: "",
            field: job.level1,
            default: job.level1 !== "",
            enabled: job.level1 !== ""
          },
          {
            level: "2",
            value: "",
            field: job.level2,
            default: job.level2 !== "",
            enabled: job.level2 !== ""
          },
          {
            level: "3",
            value: "",
            field: job.level3,
            default: job.level3 !== "",
            enabled: job.level3 !== ""
          },
          {
            level: "4",
            value: "",
            field: job.level4,
            default: job.level4 !== "",
            enabled: job.level4 !== ""
          },
          {
            level: "5",
            value: "",
            field: job.level5,
            default: job.level5 !== "",
            enabled: job.level5 !== ""
          },
          {
            level: "6",
            value: "",
            field: job.level6,
            default: job.level6 !== "",
            enabled: job.level6 !== ""
          }
        ],
        allowMetadataEdit: false
      },
      cablemodels: [],
      linkmodels: [],
      cabletypes: [],
      isNonGenericCableBrand: false,
      disabledToogleIdentifier: false,
      hasResult: false,
      testHasResultWithMetaData: false,
      findreplacetestnames: false,
      addchangeengineer: false,
      nearfarconnector: false,
      overridecableshielding: false,
      cableshielding: "STP",
      findName: "",
      replaceName: "",
      engineerName: "",
      lantek3: false,
      modalRef: React.createRef()
    };
  }

  editTestDetails = e => {
    if (
      [
        "findreplacetestnames",
        "addchangeengineer",
        "nearfarconnector"
      ].includes(e.target.name)
    ) {
      this.setState({ [e.target.name]: !this.state[e.target.name] });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  handleTabChange = (event, value) => {
    let { tabPosition } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value });
    }
  };

  tabNext() {
    let check = this.canTabNext();
    let validate = this.validate();
    if (validate && check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    let check = this.canTabBack();
    if (check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    // const { tabs, tabPosition } = this.state
    // const { multiple } = this.props
    // let pos = tabPosition + 1
    // if (multiple) {
    //   return (pos < tabs.filter(n => n).length - 1) ? { can: true, pos: pos } : false
    // }
    // return (pos < tabs.filter(n => n).length) ? { can: true, pos: pos } : false
    const { tabPosition, test, tabCounts, allowMetadataEdit } = this.state;
    const { multiple, job } = this.props;
    let isLantek = test.devicetype === "LantekIII" ? true : false;
    let isFiber = test.testedcabletype === "Fiber" ? true : false;
    let isMobile = test.devicetype === "VDVII" || test.devicetype === "VDVIIPlus" || test.devicetype === "VDVIIPro" || test.devicetype === "PoEPro";

    let pos = tabPosition + 1;
    let tabCountsCur;
    if (isMobile) {
      tabCountsCur =
        tabCounts.mobile[multiple ? "multiple" : "single"];
    }
    else if (!isLantek) {
      tabCountsCur =
        tabCounts.comet[multiple ? "multiple" : "single"][
          allowMetadataEdit ? "custom" : "standard"
        ];
    } else {
      if (isFiber) {
        tabCountsCur = multiple ? 1 : 2;
      } else {
        tabCountsCur = tabCounts.lantek[multiple ? "multiple" : "single"];
      }
    }
    return pos < tabCountsCur ? { can: true, pos: pos } : false;
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : false;
  }

  tabsComplete() {
    // const { tabs, tabPosition } = this.state
    // const { multiple } = this.props
    // if (multiple) {
    //   return (tabPosition === tabs.filter(n => n).length - 2) ? true : false
    // }
    // return (tabPosition === tabs.filter(n => n).length - 1) ? true : false
    const { tabPosition, test, tabCounts, allowMetadataEdit } = this.state;
    const { multiple, job } = this.props;
    let isLantek = test.devicetype === "LantekIII" ? true : false;
    let isFiber = test.testedcabletype === "Fiber" ? true : false;
    let isMobile = test.devicetype === "VDVII" || test.devicetype === "VDVIIPlus" || test.devicetype === "VDVIIPro" || test.devicetype === "PoEPro";

    let tabCountsCur;
    if (isMobile) {
      tabCountsCur =
        tabCounts.mobile[multiple ? "multiple" : "single"];
    }
    else if (!isLantek) {
      tabCountsCur =
        tabCounts.comet[multiple ? "multiple" : "single"][
          allowMetadataEdit ? "custom" : "standard"
        ];
    } else {
      if (isFiber) {
        tabCountsCur = multiple ? 1 : 2;
      } else {
        tabCountsCur = tabCounts.lantek[multiple ? "multiple" : "single"];
      }
    }
    return tabPosition === tabCountsCur - 1 ? true : false;
  }

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.cancel();
  };

  compare = (a, b) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  };

  onChange = e => {
    const self = this;
    let test = { ...this.state.test };
    let cablemodels = self.state.cablemodels || [];
    let linkmodels = self.state.linkmodels || [];
    let cabletypes = self.state.cabletypes || [];
    let isNonGenericCableBrand = self.state.isNonGenericCableBrand;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    if (e.target.name === "cablestandard") {
      const std = self.props.standards;
      const standard =
        std && std.cablestandards
          ? std.cablestandards.find(x => x.id == e.target.value)
          : null;
      self.setState({
        linkmodels: standard && standard.linkmodels ? standard.linkmodels : []
      });
      if (standard) {
        test.cablestandardname = standard.name;
      }
      if (test[e.target.name] && test[e.target.name] !== e.target.value) {
        test["linkmodel"] = "";
        test["cabletype"] = "";
        test["linkmodelname"] = "";
        test["cabletypename"] = "";
        self.setState({ cabletypes: [] });
      }
    }
    if (e.target.name === "linkmodel") {
      const linkModel = linkmodels
        ? linkmodels.find(x => x.id == e.target.value)
        : null;
      self.setState({
        cabletypes:
          linkModel && linkModel.cabletypes
            ? linkModel.cabletypes.sort(this.compare)
            : []
      });
      test.linkmodelname = linkModel ? linkModel.name : "";
      if (test[e.target.name] && test[e.target.name] !== e.target.value) {
        test["cabletype"] = "";
        test["cabletypename"] = "";
      }
    }

    if (e.target.name === "cabletype") {
      const cabletype = cabletypes
        ? cabletypes.find(x => x.id == e.target.value)
        : null;
      test.cabletypename = cabletype ? cabletype.name : "";
    }

    if (e.target.name === "cablebrand") {
      if (e.target.value) {
        const { standards } = self.props;
        const brand =
          standards && standards.cablebrands
            ? standards.cablebrands.find(x => x.id == e.target.value)
            : null;
        test.cablebrandname = brand ? brand.name : "";
        cablemodels = brand
          ? !this.props.isCopperTest
            ? brand.cablemodels.filter(n => n.coax == true)
            : brand.cablemodels.filter(n => n.coax == false)
          : [];
        if (brand.name.toLowerCase() == "generic") {
          isNonGenericCableBrand = false;
        } else {
          isNonGenericCableBrand = true;
        }
      }
      test.nvp = 68;
      test.cableshielding = this.props.isCopperTest ? "U/UTP" : "S/STP";
      test.cablemodelid = "";
    }
    if (e.target.name === "connectorbrandnear") {
      if (e.target.value) {
        const conns = self.props.standards;
        const connectornear =
          conns && conns.connectorbrands
            ? conns.connectorbrands.find(x => x.id == e.target.value)
            : null;
        test.connectorbrandnearname = connectornear ? connectornear.name : "";
      }
    }

    if (e.target.name === "connectorbrandfar") {
      if (e.target.value) {
        const conns = self.props.standards;
        const connectorfar =
          conns && conns.connectorbrands
            ? conns.connectorbrands.find(x => x.id == e.target.value)
            : null;
        test.connectorbrandfarname = connectorfar ? connectorfar.name : "";
      }
    }

    if (e.target.name === "cablemodelid") {
      if (e.target.value) {
        const cablemodel = cablemodels
          ? cablemodels.find(cablemodel => cablemodel.id == e.target.value)
          : null;
        if (cablemodel) {
          if (
            cablemodel.nvp &&
            (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
          ) {
            test.nvp = cablemodel.nvp;
          } else {
            test.nvp = 68;
          }

          if (cablemodel.name) {
            test.cablemodelname = cablemodel.name;
          }
          if (cablemodel.screen) {
            test.cableshielding = "S/STP";
          } else {
            test.cableshielding = "U/UTP";
          }
        } else {
          test.nvp = 68;
          test.cableshielding = this.props.isCopperTest ? "U/UTP" : "S/STP";
        }
      }
    }

    if (e.target.name === "cableshielding") { 
      if (this.state.overridecableshielding === true) {
        this.setState({cableshielding: e.target.value });
      }
    }
    else if (e.target.name === "overridecableshielding") {
      this.setState({overridecableshielding: e.target.checked });
    }
    else {
      test[e.target.name] = e.target.value;
    }

    this.setState({ test, errors, cablemodels, isNonGenericCableBrand });
  };

  onToggleChange = (e, checked) => {
    let test = { ...this.state.test };
    test[e.target.name] = checked;
    this.setState({ test: test });
  };

  onCustomCheckChange = e => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let selectValue = metadataOption.value;
    metadataOption = {
      enabled: enabled,
      value: selectValue,
      field: document.querySelector(`select[name="${e.target.name}"]`).value
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onCustomChange = e => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onChangeMetadataField = e => {
    let { test, errors } = { ...this.state };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      value
    };
    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  };

  validate = currentTab => {
    const { test } = this.state;
    let {
      tabPosition,
      hasResult,
      testHasResultWithMetaData,
      allowMetadataEdit,
      findreplacetestnames,
      addchangeengineer,
      nearfarconnector,
      findName,
      replaceName,
      engineerName
    } = this.state;
    const { job, translate, multiple } = this.props;
    let validationData = {};
    let errors = {};
    tabPosition = currentTab || currentTab === 0 ? currentTab : tabPosition;

    let isLantek = test.devicetype === "LantekIII" ? true : false;
    let isComet = test.devicetype === "Comet" ? true : false;
    let isFiber = test.testedcabletype === "Fiber" ? true : false;
    let isMobile = test.devicetype === "VDVII" || test.devicetype === "VDVIIPlus" || test.devicetype === "VDVIIPro" || test.devicetype === "PoEPro";

    if (isMobile) {
      var testDetailsTabPosition = 0;
      var testEditDetailsTabPosition = 1;
      if (multiple) {
        testDetailsTabPosition -= 1;
        testEditDetailsTabPosition -= 1;
      }
      if (tabPosition === testDetailsTabPosition || currentTab === testDetailsTabPosition) {
        validationData = {
          name: {
            required: translate("formfield_error_general_required"),
            type: {
              value: "alphanumericspecial",
              message: translate("formfield_error_general_type_alphanumeric")
            }
          }
        };
      }
      else if (tabPosition === testEditDetailsTabPosition || currentTab === testEditDetailsTabPosition) {
        if (findreplacetestnames) {
          validationData = {
            findName: {
              required: translate("formfield_error_general_required")
            }
          };
        }
        if (addchangeengineer) {
          validationData["engineerName"] = {
            required: translate("formfield_error_general_required")
          };
        }
        errors = validateFormData(
          { ...test, findName, engineerName },
          validationData
        );
      }
    }
    else if (!this.props.withAndWithoutResult) {
      if (multiple && isComet) {
        if (tabPosition === 0 || currentTab === 0) {
          validationData = {
            nvp: {
              required: translate("formfield_error_general_required"),
              range: {
                minValue: 50,
                maxValue: 99,
                message: translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })
              }
            }
          };
          errors = validateFormData(test, validationData);
        } else if (tabPosition === 1 || currentTab === 1) {
          if (findreplacetestnames) {
            validationData = {
              findName: {
                required: translate("formfield_error_general_required")
              }
            };
          }
          if (addchangeengineer) {
            validationData["engineerName"] = {
              required: translate("formfield_error_general_required")
            };
          }
          errors = validateFormData(
            { ...test, findName, engineerName },
            validationData
          );
        } else if (
          testHasResultWithMetaData &&
          (tabPosition === 2 || currentTab === 2)
        ) {
          test.metadata.map(x => {
            if (x.enabled && (x.value === null || x.value.trim() === "")) {
              errors[x.level] = true;
            } else if (x.enabled && x.value.length > 12) {
              errors[x.level] = true;
            }
          });
        }
      } else {
        if (!multiple && tabPosition === 0) {
          validationData = {
            name: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "alphanumericspecial",
                message: translate("formfield_error_general_type_alphanumeric")
              }
            }
          };
        } else if (
          (!isLantek && !multiple && tabPosition === 1 && !hasResult) ||
          (!isLantek && multiple && tabPosition === 0)
        ) {
          validationData = {
            cablestandard: {
              required: translate("formfield_error_general_required")
            },
            linkmodel: {
              required: translate("formfield_error_general_required")
            },
            cabletype: {
              required: translate("formfield_error_general_required")
            },
            cablebrand: {
              required: translate("formfield_error_general_required")
            },
            cablemodelid: {
              required: translate("formfield_error_general_required")
            },
            cableshielding: {
              required: translate("formfield_error_general_required")
            }
          };
        } else if (
          (!testHasResultWithMetaData &&
            !isLantek &&
            !multiple &&
            tabPosition === 2 &&
            !hasResult) ||
          (!isLantek && multiple && tabPosition === 1) ||
          (!isLantek && !multiple && hasResult && tabPosition === 1) ||
          (isLantek && !multiple && tabPosition === 1 && !isFiber) ||
          (isLantek && multiple && tabPosition === 0 && !isFiber)
        ) {
          validationData = {
            nvp: {
              required: translate("formfield_error_general_required"),
              range: {
                minValue: 50,
                maxValue: 99,
                message: translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })
              }
            }
          };
        } else if (
          (!isLantek && !multiple && tabPosition === 3) ||
          (!isLantek && multiple && tabPosition === 2) ||
          (!isLantek && !multiple && tabPosition === 2) ||
          (!isLantek && multiple && tabPosition === 1) ||
          (isLantek && !multiple && tabPosition === 2) ||
          (isLantek && multiple && tabPosition === 0 && isFiber) ||
          (isLantek && !multiple && tabPosition === 1 && isFiber) ||
          (!isLantek && !multiple && hasResult && tabPosition === 2) ||
          (isLantek && multiple && hasResult && tabPosition === 1 && !isFiber)
        ) {
          if (findreplacetestnames) {
            validationData = {
              findName: {
                required: translate("formfield_error_general_required")
              }
            };
          }
          if (addchangeengineer) {
            validationData["engineerName"] = {
              required: translate("formfield_error_general_required")
            };
          }
        } else if (
          ((!isLantek && !multiple && tabPosition === 4) ||
            (!isLantek && multiple && tabPosition === 3) ||
            (!isLantek &&
              !multiple &&
              tabPosition === 3 &&
              testHasResultWithMetaData) ||
            (!isLantek &&
              multiple &&
              tabPosition === 2 &&
              testHasResultWithMetaData)) &&
          allowMetadataEdit
        ) {
          test.metadata.map(x => {
            if (x.enabled && x.value.trim() === "") {
              errors[x.level] = true;
            } else if (x.enabled && x.value.length > 12) {
              errors[x.level] = true;
            }
          });
        }
        if (
          (((!isLantek && !multiple && tabPosition === 4) ||
            (!isLantek && multiple && tabPosition === 3)) &&
            allowMetadataEdit &&
            ((!isLantek && !multiple && tabPosition === currentTab) ||
              (!isLantek && multiple && tabPosition === currentTab))) ||
          ((!isLantek &&
            !multiple &&
            tabPosition === 3 &&
            testHasResultWithMetaData) ||
            (!isLantek &&
              multiple &&
              tabPosition === 2 &&
              testHasResultWithMetaData))
        ) {
        } else {
          errors = validateFormData(
            { ...test, findName, replaceName, engineerName },
            validationData
          );
        }
      }
    } else {
      if (findreplacetestnames) {
        validationData = {
          findName: {
            required: translate("formfield_error_general_required")
          }
        };
      }
      if (addchangeengineer) {
        validationData["engineerName"] = {
          required: translate("formfield_error_general_required")
        };
      }
      errors = validateFormData({ findName, engineerName }, validationData);
    }
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();

      if (Number.isInteger(parseInt(missingFieldName))) {
        toast.error(
          ` ${this.props.translate("test_create_invalid_identifier")}`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true
          }
        );
      }
    }

    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({ errors, tabPosition: currentTab });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  editTest() {
    let isValidated = false;
    const {
      tabPosition,
      allowMetadataEdit,
      findreplacetestnames,
      addchangeengineer,
      nearfarconnector,
      overridecableshielding,
      cableshielding,
      findName,
      replaceName,
      engineerName
    } = this.state;
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab);
      if (!isValidated) {
        return;
      }
    }
    if (isValidated) {
      let { test } = this.state;
      const { job, pager } = this.props;

      if (!this.validate()) {
        return;
      }

      if (!allowMetadataEdit) {
        test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
      }

      //Remove Disabled Metadata
      if (allowMetadataEdit) {
        let metadata = [...test.metadata];
        metadata.map(e => {
          if (!e.enabled) {
            e.field = "";
            e.value = "";
            return e;
          }
        });
        test.metadata = metadata;
      }
      test.allowMetadataEdit = allowMetadataEdit;
      let editDetails = {
        replace: findreplacetestnames,
        findName: findName,
        replacename: replaceName,
        addChangeConnectorManufacture: nearfarconnector,
        overrideCableShielding: overridecableshielding,
        cableShielding: cableshielding,
        connectorBrandNearName: test.connectorbrandnearname,
        connectorBrandNFarName: test.connectorbrandfarname,
        addChangeengineer: addchangeengineer,
        engineerName: engineerName
      };
      if (!this.props.isCopperTest) {
        test = {
          ...test,
          cableshielding: "S/STP"
        };
      }
      this.setState(
        {
          editSaving: true
        },
        () => {
          this.props.saveEditTest({ ...test, editDetails }, pager);
        }
      );
    }
  }

  render() {
    const {
      classes,
      translate,
      job,
      multiple,
      withAndWithoutResult,
      testNames,
      isCopperTest,
      impersonating
    } = this.props;

    let { custom, standards, error } = this.props;

    let metadataOption;

    const {
      test,
      errors,
      tabs,
      tabPosition,
      disabledToogleIdentifier,
      cablemodels,
      linkmodels,
      cabletypes,
      isNonGenericCableBrand,
      testHasResultWithMetaData,
      allowMetadataEdit,
      findreplacetestnames,
      addchangeengineer,
      nearfarconnector,
      findName,
      replaceName,
      engineerName,
      hasResult,
      lantek3,
      modalRef,
      overridecableshielding,
      cableshielding
    } = this.state;

    let isMobile = isVDVType(job.deviceid);

    let isComet = job.deviceid != null ? !isMobile : false;
    let isLantek = !isComet && !isMobile;

    let isFiber = test.testedcabletype === "Fiber" ? true : false; 

    let cablestandards, cablebrands, connectorbrands, cablemodeltypes;

    if (standards) {
      cablestandards = isCopperTest
        ? standards.cablestandards.filter(n => n.coax == false)
        : standards.cablestandards.filter(n => n.coax == true);
      cablebrands = isCopperTest
        ? standards.cablebrands.filter(
            x => x.cablemodels.filter(x => x.coax == false).length >= 1
          )
        : standards.cablebrands.filter(
            x => x.cablemodels.filter(x => x.coax == true).length >= 1
          );

      if (!isNonGenericCableBrand) {
        cablemodeltypes = isCopperTest
        ? cablemodels.filter(x => x.coax === false)
        : cablemodels.filter(x => x.coax === true);
      }

      connectorbrands = isCopperTest
        ? standards.connectorbrands.filter(
            x => x.connectormodels.filter(x => x.coax == false).length >= 1
          )
        : standards.connectorbrands.filter(
            x => x.connectormodels.filter(x => x.coax == true).length >= 1
          );
      if (!isCopperTest) {
        cablebrands = cablebrands.sort(function(a, b) {
          return a.order < b.order ? 1 : b.order < a.order ? -1 : 0;
        });
        connectorbrands = connectorbrands.sort(function(a, b) {
          return a.order < b.order ? 1 : b.order < a.order ? -1 : 0;
        });
      }
    }

    if (!custom) return null;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch = this.state.test.metadata
      ? this.state.test.metadata.filter(n => n.value).length !== 6
      : null;
    return (
      <Modal open={this.state.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_edit_title")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              {error && error === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_duplicate_error")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              {error && error === "error_testnamesize_exceeds_80chars" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {error && error === "nvp_out_of_range" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_nvp_out_of_range")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })}
                  </Typography>
                </Paper>
              )}
              {error && error === "tests_name_couldn't_be_replaced" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("testlist_couldnot_be_updated", {
                      tests: testNames.join(", ")
                    })}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_name_couldnot_be_blanck")}
                  </Typography>
                </Paper>
              )}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {test.testedcabletype !== undefined &&
                    tabs.map((tab, index) => {
                      if (index === 0) {
                        if (multiple) {
                          if (isComet) {
                            return <Tab key={index} label={tab} />;
                          }
                          return null;
                        } else {
                          return <Tab key={index} label={tab} />;
                        }
                      } else if (index === 1) {
                        if (isLantek || isMobile) {
                          return null;
                        } else {
                          return <Tab key={index} label={tab} />;
                        }
                      } else if (index === 3) {
                        return <Tab key={index} label={tab} />;
                      } else if (index === 4) {
                        if (!allowMetadataEdit || isMobile) {
                          return null;
                        } else {
                          return <Tab key={index} label={tab} />;
                        }
                      } else {
                        if (isFiber || isMobile) {
                          return null;
                        }
                        return <Tab key={index} label={tab} />;
                      }
                    })}
                </Tabs>

                {(testHasResultWithMetaData
                  ? testHasResultWithMetaData && !multiple && tabPosition === 0
                  : !multiple && tabPosition === 0) && (
                  <div className={classes.summary}>
                    <div>
                      <TextField
                        error={errors.name ? true : false}
                        required
                        name="name"
                        label={translate("test_name")}
                        margin="normal"
                        fullWidth
                        value={test.name ? test.name : ""}
                        onChange={this.onChange} 
                        inputProps={{
                          maxlength: 76
                        }}
                        helperText={
                          errors.name
                            ? errors.name
                            : translate("test_name_help")
                        }
                      />
                    </div>
                  </div>
                )}

                {((isComet && !multiple && tabPosition === 1) ||
                  (isComet &&
                    multiple &&
                    tabPosition === 0 &&
                    !withAndWithoutResult)) &&
                  test.testedcabletype === null && (
                    <div className={classes.summary}>
                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.cablestandard ? true : false}
                      >
                        <InputLabel htmlFor="cablestandard">
                          {translate("test_cable_standard")}
                        </InputLabel>
                        <Select
                          value={test.cablestandard}
                          onChange={this.onChange}
                          input={
                            <Input
                              name="cablestandard"
                              id="cablestandard"
                              value={test.cablestandard}
                            />
                          }
                          fullWidth
                        >
                          {cablestandards
                            ? cablestandards.map((standard, index) => {
                                return (
                                  <MenuItem key={index} value={standard.id}>
                                    {standard.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.cablestandard
                            ? errors.cablestandard
                            : translate("test_cable_standard_help")}
                        </FormHelperText>
                      </FormControl>

                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.linkmodel ? true : false}
                      >
                        <InputLabel htmlFor="linkmodel">
                          {translate("test_link_model")}
                        </InputLabel>
                        <Select
                          value={test.linkmodel}
                          onChange={this.onChange}
                          input={
                            <Input
                              name="linkmodel"
                              id="linkmodel"
                              value={test.linkmodel}
                            />
                          }
                          fullWidth
                        >
                          {linkmodels
                            ? linkmodels.map((linkmodel, index) => {
                                return (
                                  <MenuItem key={index} value={linkmodel.id}>
                                    {linkmodel.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.linkmodel
                            ? errors.linkmodel
                            : translate("test_link_model_help")}
                        </FormHelperText>
                      </FormControl>

                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.cabletype ? true : false}
                      >
                        <InputLabel htmlFor="cabletype">
                          {translate("test_cable_type")}
                        </InputLabel>
                        <Select
                          value={test.cabletype}
                          onChange={this.onChange}
                          input={
                            <Input
                              name="cabletype"
                              id="cabletype"
                              value={test.cabletype}
                            />
                          }
                          fullWidth
                        >
                          {cabletypes
                            ? cabletypes.map((cabletype, index) => {
                                return (
                                  <MenuItem key={index} value={cabletype.id}>
                                    {cabletype.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.cabletype
                            ? errors.cabletype
                            : translate("test_cable_type_help")}
                        </FormHelperText>
                      </FormControl>

                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.cablebrand ? true : false}
                      >
                        <InputLabel htmlFor="cablestandard">
                          {translate("test_cable_brand")}
                        </InputLabel>
                        <Select
                          value={test.cablebrand}
                          onChange={this.onChange}
                          input={
                            <Input
                              name="cablebrand"
                              id="cablebrand"
                              value={test.cablebrand}
                              fullWidth
                            />
                          }
                        >
                          {cablebrands
                            ? cablebrands.map((cablebrand, index) => {
                                return (
                                  <MenuItem key={index} value={cablebrand.id}>
                                    {cablebrand.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.cablebrand
                            ? errors.cablebrand
                            : translate("test_cable_brand_help")}
                        </FormHelperText>
                      </FormControl>

                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.cablemodelid ? true : false}
                      >
                        <InputLabel htmlFor="cablemodelid">
                          {translate("test_cable_model")}
                        </InputLabel>
                        <Select
                          value={test.cablemodelid}
                          onChange={this.onChange}
                          input={
                            <Input
                              name="cablemodelid"
                              id="cablemodelid"
                              value={test.cablemodelid}
                              fullWidth
                            />
                          }
                        >
                          {cablemodeltypes ? 
                          cablemodeltypes.map((cablemodel, index) => {
                            return (
                              <MenuItem key={index} value={cablemodel.id}>
                                {cablemodel.name}
                              </MenuItem>
                            );
                          }) :
                        cablemodels
                          ? cablemodels.map((cablemodel, index) => {
                              return (
                                <MenuItem key={index} value={cablemodel.id}>
                                  {cablemodel.name}
                                </MenuItem>
                              );
                            })
                          : null}
                        </Select>
                        <FormHelperText>
                          {errors.cablemodelid
                            ? errors.cablemodelid
                            : translate("test_cable_model_help")}
                        </FormHelperText>
                      </FormControl>

                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            margin="normal"
                            error={errors.connectorbrandnear ? true : false}
                          >
                            <InputLabel htmlFor="connectorbrandnear">
                              {translate("test_connector_brand_near")}
                            </InputLabel>
                            <Select
                              value={test.connectorbrandnear}
                              onChange={this.onChange}
                              input={
                                <Input
                                  name="connectorbrandnear"
                                  id="connectorbrandnear"
                                  value={test.connectorbrandnear}
                                  fullWidth
                                />
                              }
                            >
                              {connectorbrands
                                ? connectorbrands.map(
                                    (connectorbrand, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={connectorbrand.id}
                                        >
                                          {connectorbrand.name}
                                        </MenuItem>
                                      );
                                    }
                                  )
                                : null}
                            </Select>
                            <FormHelperText>
                              {errors.connectorbrandnear
                                ? errors.connectorbrandnear
                                : translate("test_connector_brand_near_help")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            margin="normal"
                            fullWidth
                            error={errors.connectorbrandfar ? true : false}
                          >
                            <InputLabel htmlFor="connectorbrandfar">
                              {translate("test_connector_brand_far")}
                            </InputLabel>
                            <Select
                              value={test.connectorbrandfar}
                              onChange={this.onChange}
                              input={
                                <Input
                                  name="connectorbrandfar"
                                  id="connectorbrandfar"
                                  value={test.connectorbrandfar}
                                  fullWidth
                                />
                              }
                            >
                              {connectorbrands
                                ? connectorbrands.map(
                                    (connectorbrand, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={connectorbrand.id}
                                        >
                                          {connectorbrand.name}
                                        </MenuItem>
                                      );
                                    }
                                  )
                                : null}
                            </Select>
                            <FormHelperText>
                              {errors.connectorbrandfar
                                ? errors.connectorbrandfar
                                : translate("test_connector_brand_far_help")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>

                      {isCopperTest && (
                        <FormControl
                          component="fieldset"
                          required
                          className={classes.formControl}
                          error={errors.cableshielding ? true : false}
                        >
                          <FormLabel component="legend">
                            {translate("test_cable_shielding")}
                          </FormLabel>
                          <RadioGroup
                            aria-label="gender"
                            name="cableshielding"
                            className={classes.group}
                            value={test.cableshielding}
                            onChange={this.onChange}
                          >
                            <FormControlLabel
                              disabled={true}
                              value="U/UTP"
                              control={<Radio />}
                              label={translate("test_cable_shielding_uutp")}
                            />
                            <FormControlLabel
                              disabled={true}
                              value="S/STP"
                              control={<Radio />}
                              label={translate("test_cable_shielding_sftp")}
                            />
                          </RadioGroup>
                        </FormControl>
                      )}
                    </div>
                  )}
                {((isLantek &&
                  !isFiber &&
                  ((!multiple && tabPosition === 1) ||
                    (multiple && tabPosition === 0))) ||
                  (testHasResultWithMetaData
                    ? isComet && !multiple && tabPosition === 1
                    : isComet &&
                      !multiple &&
                      tabPosition === 2 &&
                      !hasResult) ||
                  (isComet &&
                    multiple &&
                    tabPosition === 1 &&
                    test.testedcabletype == null) ||
                  (isComet &&
                    multiple &&
                    tabPosition === 0 &&
                    test.testedcabletype != null) ||
                  (isComet &&
                    !multiple &&
                    (tabPosition === 1 && test.testedcabletype != null))) && (
                  <div className={classes.summary}>
                    <TextField
                      error={errors.nvp ? true : false}
                      name="nvp"
                      label={translate("test_nvp")}
                      margin="normal"
                      fullWidth
                      value={test.nvp}
                      onChange={this.onChange}
                      disabled={isNonGenericCableBrand}
                      helperText={
                        errors.nvp ? errors.nvp : translate("test_nvp_help")
                      }
                    />
                    {(impersonating && isComet && hasResult && !withAndWithoutResult && (
                      <FormControl
                        component="fieldset"
                        required
                        className={classes.formControl}
                        error={errors.cableshielding ? true : false}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={overridecableshielding}
                              onChange={this.onChange}
                              name="overridecableshielding"
                              color="primary"
                            />
                          }
                          label={translate("test_cable_shielding")}
                        />
                        <Select
                          onChange={this.onChange}
                          input={<Input name="cableshielding" id="cableshielding" value={cableshielding} />}
                          autoWidth={false}
                          value={cableshielding}
                          disabled={!overridecableshielding}
                        >
                          <MenuItem value={'UUTP'}>{"UUTP"}</MenuItem>
                          <MenuItem value={'U/UTP'}>{"U/UTP"}</MenuItem>
                          <MenuItem value={'UTP'}>{"UTP"}</MenuItem>
                          <MenuItem value={'U/FTP'}>{"U/FTP"}</MenuItem>
                          <MenuItem value={'S/UTP'}>{"S/UTP"}</MenuItem>
                          <MenuItem value={'STP'}>{"STP"}</MenuItem>
                          <MenuItem value={'S/STP'}>{"S/STP"}</MenuItem>
                          <MenuItem value={'SF/UTP'}>{"SF/UTP"}</MenuItem>
                          <MenuItem value={'S/FTP'}>{"S/FTP"}</MenuItem>
                          <MenuItem value={'FUTP'}>{"FUTP"}</MenuItem>
                          <MenuItem value={'F/UTP'}>{"F/UTP"}</MenuItem>
                          <MenuItem value={'FTP'}>{"FTP"}</MenuItem>
                          <MenuItem value={'F/STP'}>{"F/STP"}</MenuItem>
                          <MenuItem value={'F/FTP'}>{"F/FTP"}</MenuItem>
                        </Select>
                      </FormControl>
                    ))}
                  </div>
                )}
                {((isComet &&
                  (multiple
                    ? tabPosition === 1 && hasResult
                    : hasResult
                    ? tabPosition === 2
                    : tabPosition === 3)) ||
                  (isComet && !multiple && tabPosition === 3 && !hasResult) ||
                  (isComet && multiple && tabPosition === 2 && !hasResult) ||
                  (isLantek && !multiple && tabPosition === 2) ||
                  (isLantek && multiple && tabPosition === 1) ||
                  (isLantek && !multiple && tabPosition === 1 && isFiber) ||
                  (isLantek && multiple && tabPosition === 0 && isFiber) ||
                  (isMobile && multiple && tabPosition === 0) ||
                  (isMobile && !multiple && tabPosition === 1) ||
                  (isComet &&
                    multiple &&
                    tabPosition === 0 &&
                    withAndWithoutResult)) && (
                  <div className={classes.summary}>
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="findreplacetestnames"
                            checked={findreplacetestnames}
                            onChange={this.editTestDetails}
                          />
                        }
                        label={<b>{translate("find_and_replace_test_name")}</b>}
                      />
                    </Typography>
                    {findreplacetestnames ? (
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.findName ? true : false}
                            name="findName"
                            label={translate("test_name_find")}
                            margin="normal"
                            fullWidth
                            value={findName}
                            onChange={this.editTestDetails}
                            helperText={
                              errors.findName
                                ? errors.findName
                                : translate("test_name_find_helper")
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.replaceName ? true : false}
                            label={translate("test_name_replace")}
                            name="replaceName"
                            margin="normal"
                            fullWidth
                            value={replaceName}
                            onChange={this.editTestDetails}
                            inputProps={{
                              maxlength: 80
                            }}
                            helperText={
                              errors.replaceName
                                ? errors.replaceName 
                                : translate("test_name_replace_helper")
                            }
                          />
                        </Grid>
                      </Grid>
                    ) : null}
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="addchangeengineer"
                            checked={addchangeengineer}
                            onChange={this.editTestDetails}
                            disabled={!hasResult && !isMobile}
                          />
                        }
                        label={
                          !hasResult && !isMobile ? (
                            <Typography style={{ color: "#dddddd" }}>
                              {" "}
                              <b>{translate("add_or_change_engineer")}</b>
                            </Typography>
                          ) : (
                            <b>{translate("add_or_change_engineer")}</b>
                          )
                        }
                      />
                    </Typography>
                    {addchangeengineer ? (
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.engineerName ? true : false}
                            name="engineerName"
                            label={translate("test_engineer_name")}
                            margin="normal"
                            fullWidth
                            value={engineerName}
                            onChange={this.editTestDetails}
                            helperText={
                              errors.engineerName
                                ? errors.engineerName
                                : translate("test_engineer_name_helper")
                            }
                          />
                        </Grid>
                      </Grid>
                    ) : null}
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="nearfarconnector"
                            checked={nearfarconnector}
                            onChange={this.editTestDetails}
                            disabled={lantek3 || isMobile}
                          />
                        }
                        label={
                          lantek3 || isMobile ? (
                            <Typography style={{ color: "#dddddd" }}>
                              {" "}
                              <b>
                                {translate("update_near_far_end_connector")}
                              </b>
                            </Typography>
                          ) : (
                            <b>{translate("update_near_far_end_connector")}</b>
                          )
                        }
                      />
                    </Typography>
                    {nearfarconnector ? (
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            margin="normal"
                            error={errors.connectorbrandnear ? true : false}
                          >
                            <InputLabel htmlFor="connectorbrandnear">
                              {translate("test_connector_brand_near")}
                            </InputLabel>
                            <Select
                              value={test.connectorbrandnear}
                              onChange={this.onChange}
                              input={
                                <Input
                                  name="connectorbrandnear"
                                  id="connectorbrandnear"
                                  value={test.connectorbrandnear}
                                  fullWidth
                                />
                              }
                            >
                              {connectorbrands
                                ? connectorbrands.map(
                                    (connectorbrand, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={connectorbrand.id}
                                        >
                                          {connectorbrand.name}
                                        </MenuItem>
                                      );
                                    }
                                  )
                                : null}
                            </Select>
                            <FormHelperText>
                              {errors.connectorbrandnear
                                ? errors.connectorbrandnear
                                : translate("test_connector_brand_near")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            margin="normal"
                            fullWidth
                            error={errors.connectorbrandfar ? true : false}
                          >
                            <InputLabel htmlFor="connectorbrandfar">
                              {translate("test_connector_brand_far_helper")}
                            </InputLabel>
                            <Select
                              value={test.connectorbrandfar}
                              onChange={this.onChange}
                              input={
                                <Input
                                  name="connectorbrandfar"
                                  id="connectorbrandfar"
                                  value={test.connectorbrandfar}
                                  fullWidth
                                />
                              }
                            >
                              {connectorbrands
                                ? connectorbrands.map(
                                    (connectorbrand, index) => {
                                      return (
                                        <MenuItem
                                          key={index}
                                          value={connectorbrand.id}
                                        >
                                          {connectorbrand.name}
                                        </MenuItem>
                                      );
                                    }
                                  )
                                : null}
                            </Select>
                            <FormHelperText>
                              {errors.connectorbrandfar
                                ? errors.connectorbrandfar
                                : translate("test_connector_brand_far_helper")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : null}
                  </div>
                )}
                {((isComet &&
                  testHasResultWithMetaData &&
                  (multiple ? tabPosition === 2 : tabPosition === 3)) ||
                  (isComet && !multiple && tabPosition === 4) ||
                  (isComet &&
                    multiple &&
                    tabPosition === 3 &&
                    allowMetadataEdit)) && (
                  <div className={classes.summary}>
                    {showAllMetadataSwitch && (
                      <Typography type="subheading">
                        <FormControlLabel
                          control={
                            <Switch
                              name="allmetadataoptions"
                              checked={test.allmetadataoptions}
                              color="secondary"
                              onChange={(e, checked) =>
                                this.onToggleChange(e, checked)
                              }
                              disabled={disabledToogleIdentifier}
                            />
                          }
                          label={translate("test_add_metadata_item")}
                        />
                      </Typography>
                    )}

                    {custom &&
                      custom
                        .sort((a, b) => {
                          return a.level > b.level
                            ? -1
                            : a.level < b.level
                            ? 1
                            : 0;
                        })
                        .map((c, index) => {
                          metadataOption = test.metadata.find(
                            x => parseInt(x.level, 10) === parseInt(c.level, 10)
                          );
                          return (test.allmetadataoptions ||
                            metadataOption.default ||
                            metadataOption.enabled) &&
                            c.level !== 1 ? (
                            <div key={index}>
                              <Checkbox
                                name={c.level}
                                checked={metadataOption.enabled}
                                onChange={this.onCustomCheckChange}
                              />
                              <select
                                name={c.level}
                                value={metadataOption.field}
                                onChange={this.onCustomChange}
                                disabled={!metadataOption.enabled}
                              >
                                {c.values.map((o, index) => {
                                  return (
                                    <option key={index} value={o.id}>
                                      {o.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <TextField
                                error={errors[c.level] ? true : false}
                                required
                                name={c.level}
                                margin="normal"
                                value={metadataOption.value}
                                onChange={this.onChangeMetadataField}
                                disabled={!metadataOption.enabled}
                              />
                            </div>
                          ) : null;
                        })}
                  </div>
                )}
              </form>
            </ModalContents>

            <ModalFooter>
              <Button
                raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={!this.canTabBack().can ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button
                raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={!this.canTabNext().can ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {this.tabsComplete() ? (
                <Button
                  raised
                  color="accent"
                  className={classes.submit}
                  onClick={() => this.editTest()}
                  type="submit"
                >
                  {translate("test_edit")}
                </Button>
              ) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }

  componentDidMount() {
    const { job, test, translate } = this.props;
    const disabledToogleIdentifier = this.state.test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      translate,
      job,
      standards,
      multiple,
      selectedTests,
      withAndWithoutResult
    } = this.props;
    const { test } = nextProps;
    const { editSaving } = this.state;
    let {
      cablemodels,
      linkmodels,
      cabletypes,
      isNonGenericCableBrand,
      testHasResultWithMetaData,
      hasResult,
      allowMetadataEdit
    } = this.state;
    if (test && !editSaving) {
      if (test && test.devicetype === "LantekIII") {
        hasResult = true;
        this.setState({ lantek3: true });
      }
      if (test && test.Technician) {
        this.setState({ engineerName: test.Technician });
      }
      if (test.metadata) {
        let metadata = [...test.metadata];
        let curStateMetaData = [...this.state.test.metadata];
        metadata.forEach(e => {
          curStateMetaData.forEach(ce => {
            if (ce.level === e.level) {
              ce.field = e.field;
              ce.value = e.value;
              e.value ? (ce.enabled = true) : (ce.enabled = false);
            }
          });
        });
        test.metadata = curStateMetaData;
      }
      let identifierTestCount = 0;
      selectedTests.forEach(test => {
        const {
          level2key,
          level2value,
          level3key,
          level3value,
          level4key,
          level4value,
          level5key,
          level5value,
          level6key,
          level6value
        } = test;
        if (test)
          if (
            level2key ||
            level2value ||
            level3key ||
            level3value ||
            level4key ||
            level4value ||
            level5key ||
            level5value ||
            level6key ||
            level6value
          ) {
            identifierTestCount++;
          }
      });
      allowMetadataEdit = [selectedTests.length].includes(identifierTestCount)
        ? true
        : false;

      if (job.deviceid && test.devicetype === "Comet") {
        test.nvp = [undefined, null].includes(test.nvp) ? "0" : "" + test.nvp;
        hasResult = true;
        let tabs;
        if (multiple && withAndWithoutResult) {
          tabs = [translate("test_edit_details")];
        } else if (multiple) {
          tabs = [translate("test_nvp"), translate("test_edit_details")];
        } else {
          tabs = [
            translate("test_details"),
            translate("test_nvp"),
            translate("test_edit_details")
          ];
        }

        if (allowMetadataEdit) {
          if (hasResult && allowMetadataEdit) {
            testHasResultWithMetaData = true;
            tabs.push(translate("test_metadata"));
          } else if (!hasResult && allowMetadataEdit) {
            tabs.push(translate("test_metadata"));
          }
        }

        this.setState({
          tabs: tabs,
          tabCounts: {
            comet: {
              single: {
                standard: 3,
                custom: 4
              },
              multiple: {
                standard: withAndWithoutResult ? 1 : 2,
                custom: hasResult
                  ? allowMetadataEdit
                    ? withAndWithoutResult
                      ? 1
                      : 3
                    : withAndWithoutResult
                    ? 1
                    : 2
                  : allowMetadataEdit
                  ? withAndWithoutResult
                    ? 1
                    : 4
                  : withAndWithoutResult
                  ? 1
                  : 3
              }
            },
            lantek: {
              single: 3,
              multiple: withAndWithoutResult ? 1 : 2
            },
            mobile: {
              single: 2,
              multiple: 1
            }
          }
        });
      }

      if (job.deviceid && !test.devicetype) {
        let tabs;
        if (multiple && withAndWithoutResult) {
          tabs = [translate("test_edit_details")];
        } else if (multiple) {
          tabs = [
            translate("test_standards"),
            translate("test_nvp"),
            translate("test_edit_details")
          ];
        } else {
          tabs = [
            translate("test_details"),
            translate("test_standards"),
            translate("test_nvp"),
            translate("test_edit_details")
          ];
        }
        if (allowMetadataEdit) {
          tabs.push(translate("test_metadata"));
        }
        this.setState({
          tabs: tabs,
          tabCounts: {
            comet: {
              single: {
                standard: 4,
                custom: 5
              },
              multiple: {
                standard: withAndWithoutResult ? 1 : 3,
                custom: hasResult
                  ? allowMetadataEdit
                    ? withAndWithoutResult
                      ? 1
                      : 3
                    : withAndWithoutResult
                    ? 1
                    : 2
                  : allowMetadataEdit
                  ? withAndWithoutResult
                    ? 1
                    : 4
                  : withAndWithoutResult
                  ? 1
                  : 3
              }
            },
            lantek: {
              single: 3,
              multiple: withAndWithoutResult ? 1 : 2
            }
          }
        });
      }

      if (test.cablebrand) {
        const brand =
          standards && standards.cablebrands
            ? standards.cablebrands.find(x => x.id == test.cablebrand)
            : null;
        if (brand) {
          if (brand.name.toLowerCase() == "generic") {
            isNonGenericCableBrand = false;
          } else {
            isNonGenericCableBrand = true;
          }
          cablemodels = brand.cablemodels || [];
        }
      }
      if (test.cablestandard) {
        const standard =
          standards && standards.cablestandards
            ? standards.cablestandards.find(x => x.id == test.cablestandard)
            : null;
        linkmodels =
          standard && standard.linkmodels ? standard.linkmodels : null;
      }
      if (test.linkmodel) {
        const linkmodel = linkmodels
          ? linkmodels.find(x => x.id == test.linkmodel)
          : null;
        cabletypes =
          linkmodel && linkmodel.cabletypes ? linkmodel.cabletypes : null;
      }

      this.setState({
        test,
        cablemodels,
        linkmodels,
        cabletypes,
        isNonGenericCableBrand,
        hasResult,
        testHasResultWithMetaData,
        allowMetadataEdit
      });
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }
}

export default withStyles(styles)(EditTests);



// WEBPACK FOOTER //
// ./src/components/job/edit/index.js